import { Project, ProjectDTO } from './Project'
import { Brand } from './Brand'
import { Product } from './Product'

export enum FilterTypes {
  PROJECTS = 'Projects',
  BRANDS = 'Brands',
  PRODUCTS = 'Products'
  // BRANDS_AND_PRODUCTS = 'Brands and Products',
  // TIME_LINE_TAG = 'Time Line Tag',
  // INTERACTIVE_AREA_TAG = 'Interactive Area Tag'
}

export interface AgreementScopeFilterDTO {
  brands: Brand[]
  budget: number
  id: number
  products: Product[]
  projects: ProjectDTO[]
  type: FilterTypes
  values: string
}

export class AgreementScopeFilter {
  id: number
  type: FilterTypes
  budget: number
  values: string
  projects: Project[]
  brands: Brand[]
  products: Product[]

  constructor (filter: AgreementScopeFilter) {
    for (const property in filter) {
      this[property] = filter[property]
    }
  }
}
